import React from 'react'

function Midnav() {
  return (
    <div className="midnav">
      <img src="./img/Group 59537.svg" alt="" className="mid-img1" />
      <img src="./img/Group 4040.svg" alt="" className="mid-img2" />
      <img src="./img/Frame 4041.svg" alt="" className="mid-img3" />
    </div>
  )
}

export default Midnav
